/* IEs polyfills  */
import 'babel-polyfill'
import 'ima.js-babel6-polyfill'
/* */
import React from 'react'
import ReactDOM from 'react-dom'
import BookingForm from './BookingForm'
import './styles/app.less'
import { getURLParams } from './helpers.js'

let params = getURLParams(document.location.href)
let container = document.querySelector('[data-bf-container=true]') || document.body

ReactDOM.render(<BookingForm {...params} />, container)



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/